import handlePromise from 'utils/handle-promise'

export async function addPersonalProjectService({ token, formData }) {
  const data = await handlePromise('/api/v1/portfolio-projects/', {
    headers: {
      Authorization: token,
    },
    method: 'POST',
    body: formData,
  })
  return data
}

export async function editPersonalProjectService({ uuid, token, formData }) {
  const data = await handlePromise(`/api/v1/portfolio-projects/${uuid}/`, {
    headers: {
      Authorization: token,
    },
    method: 'PUT',
    body: formData,
  })
  return data
}

export async function toggleTestimonyVisibilityService({ token, uuid }) {
  const data = await handlePromise(`/api/v1/portfolio-projects/${uuid}`, {
    headers: { Authorization: token },
    method: 'PATCH',
  })
  return data
}

export async function removePersonalProjectService({ token, uuid }) {
  const data = await handlePromise(`/api/v1/portfolio-projects/${uuid}/`, {
    headers: { Authorization: token },
    method: 'DELETE',
  })
  return data
}

export async function searchPortfolioProjectService({ token, query }) {
  const data = await handlePromise(`/api/v1/portfolio-projects/search/?q=${query}`, {
    headers: { Authorization: token },
    method: 'GET',
  })
  return data
}

export async function savePortfolioDataService({ token, payload }) {
  const data = await handlePromise('/api/v1/me/portfolio/', {
    headers: { Authorization: token },
    method: 'PUT',
    body: payload,
  })
  return data
}

export async function getTestimoniesService({ token }) {
  const data = await handlePromise('/api/v1/testimonies/', {
    headers: { Authorization: token },
    method: 'GET',
  })
  return data
}

export async function createTestimonyService({ token, payload }) {
  const data = await handlePromise('/api/v1/testimonies/', {
    headers: { Authorization: token },
    method: 'POST',
    body: payload,
  })
  return data
}

export async function updateTestimonyService({ token, payload, uuid }) {
  const data = await handlePromise(`/api/v1/testimonies/?uuid=${uuid}`, {
    headers: { Authorization: token },
    method: 'PUT',
    body: payload,
  })
  return data
}

export async function deleteTestimonyService({ token, uuid }) {
  const data = await handlePromise(`/api/v1/testimonies/?uuid=${uuid}`, {
    headers: { Authorization: token },
    method: 'DELETE',
  })
  return data
}

export async function saveSocialMediaService({ payload, token }) {
  const data = await handlePromise('/api/v1/me/social-media/', {
    headers: { Authorization: token },
    method: 'PUT',
    body: payload,
  })
  return data
}
